<template>
    <section>
        <a-col :span="24" :md="24" :lg="24" :xl="24" class="mb-0">
            <a-page-header
                style="border: 0px solid rgb(235, 237, 240)"
                :title="$t('form-label.application-details')"
            >
                <!-- @back="() => navigateBack()" -->
            </a-page-header>
            <a-card 
                :loading="data.isLoading" 
                :bordered="false" 
                class="header-solid h-full" 
            >
                <!-- style="background-color:#ebeced;" -->
                <template #title>
                    <div style="display:flex; flex-direction: row;">                     
                        <a-avatar
                            :size="94"
                            shape="square"
                            :src="profileImageUrl"
                            @click="onImageClick(profileImageUrl)"
                        />
                        
                        <div style="margin-left: 20px;">
                            <h6 class="font-semibold mb-10" >{{ companyName }}</h6>
                            <p style="font-weight: 600;"> {{ mobileNo }} </p>
                            <p style="font-weight: 600;"> {{ email }} </p>
                            <p style="font-weight: 600;"> {{ ownershipeType }} </p>
                        </div>
                    </div>
                </template>

                <template #extra>
                    <h5 class="font-semibold" v-if="data.status == 'APPROVED'">{{$t('form-label.code') }} : {{ data.code }}</h5>
                    <h3 class="font-semibold" :style="color">
                        <a-icon type="check" :style="{ 'font-weight': 900, 'font-size': '30px' }" v-show="data.status == 'APPROVED'"/> 
                        <a-icon type="close" :style="{ 'font-weight': 900, 'color': 'red', 'font-size': '30px' }" v-show="data.status == 'REJECTED'"/> 
                        {{ status }}
                    </h3>
                    <!-- <h5 style="font-weight: 600;"> {{ status }} </h5> -->
                    <h6 class="font-semibold" >{{ type }}</h6>
                    <h6 class="font-semibold text-md mb-0" v-if="data.status != 'APPROVED'" >{{$t('form-label.date') }} : {{ date }}</h6>
                    <h6 class="font-semibold text-md mb-0" v-if="data.status == 'APPROVED'" >{{$t('form-label.approve-date')}} : {{ approveDate }}</h6>
                    <h6 class="font-semibold text-md mb-10" v-if="data.status == 'APPROVED'" >{{$t('form-label.renewal-date')}} : {{ renewalDate }}</h6>
                    <section class="mt-10">
                        <button 
                            v-if="data.status == 'APPROVED'"
                            class="mr-10"
                            style="background-color:#06674a;
                                    border-color:#06674a;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 600;
                                    border-radius: 15px;
                                    cursor: pointer
                                "
                            @click.prevent="downloadCertificatePdf"
                        >{{ $t('form-label.download-btn-caption')}}</button>
    
                        <button 
                            style="background-color:#5d9dd3;
                                    border-color:#5d9dd3;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 600;
                                    border-radius: 15px;
                                    cursor: pointer
                                "
                            @click.prevent="downloadApplicationPdf"
                        >{{ $t('form-label.download-application-btn-caption')}}</button>
                    </section>

                </template>

                <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;" >
                    <a-tabs :activeKey="activeKey" @change="onChangeTab" style="width: 100%">
                        <a-tab-pane key="1" :tab="$t('tab-items.information')">
                            <informations :data="data"/>
                        </a-tab-pane>
                        <a-tab-pane key="2" :tab="$t('tab-items.documents')">
                            <documents :data="data" />
                        </a-tab-pane>
                        <a-tab-pane key="3" :tab="$t('tab-items.previous-works')">
                            <previous-work v-for="(item, i) in data.works" :key="i" :data="item"/>
                        </a-tab-pane>
                        <a-tab-pane key="4" :tab="$t('tab-items.ownership')">
                            <individuals :individuals="data.individuals"/>
                        </a-tab-pane>
                        <a-tab-pane key="5" :tab="$t('tab-items.technical-person')">
                            <technical-persons :individuals="data.individuals"/>
                        </a-tab-pane>
                         <a-tab-pane key="6" :tab="$t('tab-items.equipments')">
                            <equipments v-for="(item, i) in data.equipments" :key="i" :data="item"/>
                        </a-tab-pane>
                        <a-tab-pane key="7" :tab="$t('tab-items.payment')">
                            <payment-histories :data="data"/>
                        </a-tab-pane>
                        <a-tab-pane key="8" :tab="$t('tab-items.work-rating')">
                            <work-histories :data="data"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>

                
                <div class="ant-row-flex ant-row-flex-end" style="margin: 6px;">
                    <div class="ml-auto ant-col" style="padding: 20px; ">
                        <button 
                            v-if="data.paymentStatus != 'VERIFIED'"
                            style="background-color:#06674a;
                                    border-color:#06674a;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 700;
                                    border-radius: 15px;
                                    cursor: pointer;
                                "
                            @click.prevent="$refs.confirmPaymentModal.showModal(data.id)"
                        >{{ $t('form-label.confirm-payment-btn-caption')}}
                        </button>

                        <button 
                            v-if="data.status == 'APPROVED'"
                            class="ml-20"
                            style="background-color:#06674a;
                                    border-color:#06674a;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 700;
                                    border-radius: 15px;
                                    cursor: pointer;
                                "
                            @click.prevent="$refs.addTrackModal.showModal(data.id, data.type)"
                        >{{ $t('form-label.track-record-btn-caption')}}
                        </button>

                        <button 
                            v-if="data.status != 'APPROVED'"
                            class="ml-20"
                            style="background-color:#06674a;
                                    border-color:#06674a;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 700;
                                    border-radius: 15px;
                                    cursor: pointer;
                                "
                            @click.prevent="$refs.approveModal.showModal(data.id, data.status)"
                        >{{ approveButtonText }}</button>

                        <button class="ml-20" 
                                style="background-color:red;
                                    border-color:red;
                                    color:#fff;
                                    padding: 7px 20px;
                                    font-weight: 700;
                                    border-radius: 15px;
                                    cursor: pointer;
                                "
                                @click.prevent="$refs.recheckModal.showModal(data.id)"
                        >{{$t('form-label.recheck-btn-caption')}}
                        </button>
                        
                        <button class="ml-20" 
                                style="background-color:red;
                                    border-color:red;
                                    color:#fff;
                                    padding: 7px 10px;
                                    font-weight: 700;
                                    border-radius: 15px;
                                    cursor: pointer;
                                "
                                @click.prevent="$refs.rejectModal.showModal(data.id)"
                        >{{$t('form-label.reject-btn-caption')}}
                        </button>

                    </div>
                </div>
            </a-card>

            <add-track-record-modal ref="addTrackModal"/>
            <company-confirm-payment-modal ref="confirmPaymentModal"/>
            <company-approve-modal ref="approveModal"  @status-changed="statusChanged" />
            <company-recheck-modal ref="recheckModal"/>
            <company-reject-modal ref="rejectModal" @status-changed="statusChanged"/>
            
            <CoolLightBox 
                :items="images" 
                :index="index"
                @close="index = null">
            </CoolLightBox>
        </a-col>
    </section>
</template>

<script>
import { mapState } from "pinia";
import { host, apiKey } from "../../../api/config.js";
import { useLocaleStore } from "../../../stores/locale-store.js";
import { navigationMixin } from "../../../mixins/navigation-mixin.js";

import Informations from "./tab-views/developer-company/Informations.vue";
import Documents from "./tab-views/developer-company/Documents.vue";
import PreviousWork from "./tab-views/developer-company/PreviousWork.vue";
import Individuals from "./tab-views/developer-company/Individuals.vue";
import TechnicalPersons from "./tab-views/developer-company/TechnicalPersons.vue";
import Equipments from "./tab-views/developer-company/Equipments.vue";
import PaymentHistories from "./tab-views/developer-company/PaymentHistories.vue";
import WorkHistories from "./tab-views/developer-company/WorkHistories.vue";

import CompanyConfirmPaymentModal from "./modal/CompanyConfirmPaymentModal.vue";
import AddTrackRecordModal from "./modal/AddTrackRecordModal.vue"
import CompanyApproveModal from "./modal/CompanyApproveModal.vue";
import CompanyRecheckModal from "./modal/CompanyRecheckModal.vue";
import CompanyRejectModal from "./modal/CompanyRejectModal.vue";

import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

import { saveAs } from 'file-saver';

export default {
    name: "DeveloperCompanyApplicationReview",
    mixins: [ navigationMixin ],
    components:{
        Informations,
        Documents,
        PreviousWork,
        Individuals,
        TechnicalPersons,
        Equipments,
        PaymentHistories,
        WorkHistories,

        CompanyConfirmPaymentModal,
        CompanyApproveModal,
        CompanyRejectModal,
        CompanyRecheckModal,
        AddTrackRecordModal,

        CoolLightBox
    },
    props: {
        data:{
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            index: null,
            activeKey: "1",
        };
    },
    computed: {
         ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        },

        approveButtonText() {
            if (this.data) {
                if (this.data.status == 'PENDING')
                    return this.$t("form-label.forward-committe-head-btn-caption");
                else if (this.data.status == 'PENDING1') {
                    return this.$t("form-label.forward-chairman-btn-caption");
                } else if (this.data.status == 'PENDING2') {
                    return this.$t("form-label.approve-btn-caption");
                } else
                    return this.$t('form-label.already-approved-btn-caption');
            } else {
                return this.$t('form-label.already-approved-btn-caption');
            }
        },

        images() {
            let arr = [];
            let img = this.profileImageUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.tinUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.binUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.tradeLicenseUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.deedUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.incorporationCertificateUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.memorandumUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.nameClearanceUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);

            img = this.signatureUrl1;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.signatureUrl2;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.signatureUrl3;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            return arr;
        },

        color(){
            console.log(this.data);
            if (this.data.status == 'APPROVED'){
                return "color:" + "#06674a"
            } else if (this.data.status == 'REJECTED'){
                return "color:" + "red"
            } 
            return "color:" + "#000"
        },

        status(){
            if (this.data.status == "PENDING" || this.data.status == "PENDING1" || this.data.status == "PENDING2")
                return this.$t('radio-btn-caption.pending');
            else if (this.data.status == "APPROVED")
                return this.$t('radio-btn-caption.approved');
            else if (this.data.status == "REJECTED")
                return this.$t('radio-btn-caption.rejected');
            return "";
        },

        type(){
            if (this.data.type == "ARCHITECT"){
                return this.$t('radio-btn-caption.architect');
            } else if (this.data.type == "ENGINEER"){
                return this.$t('radio-btn-caption.engineer');
            } else if (this.data.type == "PLANNER"){
                return this.$t('radio-btn-caption.planner');
            } else if (this.data.type == "DEVELOPER_COMPANY"){
                return this.$t('radio-btn-caption.developer-company');
            } else if (this.data.type == "DEVELOPER"){
                return this.$t('radio-btn-caption.developer');
            } else if (this.data.type == "CONSTRUCTION_COMPANY"){
                return this.$t('radio-btn-caption.construction-company');
            }
            return "";
        },

        profileImageUrl(){
            // console.log(this.data);
            if (this.data && this.data.imageUrl && this.data.imageUrl.length > 0){
                return host + this.data.imageUrl;
            }
            return '/images/company-default.png';
        },

        companyName() {
            if (this.data){
                if (this.isLocal == "bn" && this.data.nameBn) {
                    return this.$t('form-label.name')  + " : " + this.data.nameBn;
                }else if (this.isLocal == "en" && this.data.nameEn) {
                    return this.$t('form-label.name') + " : " + this.data.nameEn;
                }
            }
            return this.$t('form-label.name') + " : ";
        },

        mobileNo(){
                if (this.data && this.data.mobileNo){
                return this.$t('form-label.alt-mobile') + " : " + this.data.mobileNo;
            }
            return this.$t('form-label.alt-mobile') + " : ";
        },

        email(){
            if (this.data && this.data.email){
                return this.$t('form-label.email') + " : " + this.data.email;
            }
            return this.$t('form-label.email') + " : ";
        },

        ownershipeType(){
            if (this.data && this.data.ownership){
                return this.$t('form-label.ownership-type') + " : " + this.data.ownership;
            }
            return this.$t('form-label.ownership-type') + " : ";
        },

        telePhone(){
            if (this.data && this.data.telNo){
                return this.$t('form-label.alt-phone') + " : " + this.data.telNo;
            }
            return this.$t('form-label.alt-phone') + " : ";
        },

        fax(){
            if (this.data && this.data.faxNo){
                return this.$t('form-label.alt-fax') + " : " + this.data.faxNo;
            }
            return this.$t('form-label.alt-fax') + " : ";
        },

        address(){
            if (this.data && this.data.address){
                return this.$t('form-label.address') + " :  " + this.data.address;
            }
            return this.$t('form-label.address') + " :  ";
        },

        tinNo(){
            if (this.data && this.data.tin){
                return this.$t('form-label.tin') + " : " + this.data.tin;
            }
            return this.$t('form-label.tin') + " : ";
        },

        tinUrl(){
             if (this.data && this.data.tinUrl && this.data.tinUrl.length > 0){
                return host + this.data.tinUrl;
            }
            return '/images/tin-default.png';
        },

        binNo(){
            if (this.data && this.data.bin){
                return this.$t('form-label.bin') + " : " + this.data.bin;
            }
            return this.$t('form-label.bin') + " : ";
        },

        binUrl(){
             if (this.data && this.data.binUrl && this.data.binUrl.length > 0){
                return host + this.data.binUrl;
            }
            return '/images/vat-default.jpg';
        },

        tradeLicenseNo(){
            if (this.data && this.data.tradeLicense){
                return this.$t('form-label.trade-license') + " : " + this.data.tradeLicense;
            }
            return this.$t('form-label.trade-license') + " : ";
        },

        tradeLicenseUrl(){
            if (this.data && this.data.tradeLicenseUrl && this.data.tradeLicenseUrl.length > 0){
                return host + this.data.tradeLicenseUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },

        deedUrl(){
            if (this.data && this.data.deedUrl && this.data.deedUrl.length > 0){
                return host + this.data.deedUrl;
            }
            return '/images/tradeLicense-default.jpg';
        },

        incorporationCertificateUrl(){
            if (this.data && this.data.incorporationCertificateUrl && this.data.incorporationCertificateUrl.length > 0){
                return host + this.data.incorporationCertificateUrl;
            }
            return '/images/certificate-default.jpg';
        },

        memorandumUrl(){
            if (this.data && this.data.memorandumUrl && this.data.memorandumUrl.length > 0){
                return host + this.data.memorandumUrl;
            }
            return '/images/certificate-default.jpg';
        },

        nameClearanceUrl(){
            if (this.data && this.data.nameClearanceUrl && this.data.nameClearanceUrl.length > 0){
                return host + this.data.nameClearanceUrl;
            }
            return '/images/certificate-default.jpg';
        },

        signatureUrl1(){
            if (this.data && this.data.signatureUrl1 && this.data.signatureUrl1.length > 0){
                return host + this.data.signatureUrl1;
            }
            return '';
        },
        signatureUrl2(){
            if (this.data && this.data.signatureUrl2 && this.data.signatureUrl2.length > 0){
                return host + this.data.signatureUrl2;
            }
            return '';
        },
        signatureUrl3(){
            if (this.data && this.data.signatureUrl3 && this.data.signatureUrl3.length > 0){
                return host + this.data.signatureUrl3;
            }
            return '';
        },

        date() {
            if (this.data) {
                if (this.data.status == 'PENDING' || this.data.status == 'PENDING1' || this.data.status == 'PENDING2' || this.data.status == 'REJECTED') {
                    return this.$d(new Date(this.data.dateCreated), 'short');
                } else {
                    if (this.data.dateTs) {
                        let h = this.data.hour;
                        let suffix = this.$t('time.am');
                        if (h > 12) {
                            h -= 12;
                            suffix = this.$t('time.pm');
                        }

                        let time = this.$n(h).padStart(2, this.$n(0) + '') + ":" + this.$n(this.data.min).padStart(2, this.$n(0) + '') + ' ' + suffix;
                        // console.log(this.data.dateTs);
                        let date = this.$d(new Date(this.data.dateTs), 'short');
                        return date + ", " + time;
                    } else {
                        return '';
                    }
                }
            }
        },
        
        approveDate(){
            if (this.data) {
                if (this.data.status == "APPROVED" ) {
                    return this.$d(new Date(this.data.approvalTs), 'short');
                } else {
                    return '';
                }
            }
        },

        renewalDate(){
            if (this.data) {
                if (this.data.status == "APPROVED" ) {
                    return this.$d(new Date(this.data.renewalTs), 'short');
                } else {
                    return '';
                }
            }
        },
    },
    methods:{
        onChangeTab(e){
            this.activeKey = e;
        },
        downloadCertificatePdf(){
            fetch(host + "/api/apps/company/pdf" + "?id=" + this.data.id , {
                headers: {
                    'Content-Type': 'application/pdf',
                    "X-API-KEY": apiKey
                },
                responseType: 'blob'
                }).then(response => response.blob())
                .then(blob => saveAs(blob, 'certificate.pdf'));
        },

        downloadApplicationPdf(){
            fetch(host + "/api/apps/company/pdf/full" + "?id=" + this.data.id , {
                headers: {
                    'Content-Type': 'application/pdf',
                    "X-API-KEY": apiKey
                },
                responseType: 'blob'
                }).then(response => response.blob())
                .then(blob => saveAs(blob, 'certificate.pdf'));
        },
        onImageClick(url) {
            let index = this.images.findIndex(e => e == url);
            if (index > -1) {
                this.index = index;
            }
            
        },
        statusChanged(evt) {
            this.$emit('status-changed', evt);
        }
    }
   
}
</script>

<style>

</style>